export default __webpack_public_path__ + "static/media/charcuterie.c420d006.webp";